import { axios } from "lib/axios"
import { auth } from "lib/firebase"
import { selectedMembershipId } from "lib/companySwitch"
import { signInWithEmailAndPassword } from 'firebase/auth';
import { sendVerificationEmailIfAllowed } from './sendVerificationEmail';

export const loginWithEmailAndPassword = async (data) => {
  try {
    await signInWithEmailAndPassword(auth, data.companyEmail, data.password);
  } catch (error) {
    if (error.code === 'auth/invalid-login-credentials' || error.code === 'auth/invalid-credential') {
      throw new Error("Invalid credentials");
    } else if (error.code === 'auth/too-many-requests') {
      throw new Error("Too many requests. Please try again later or reset your password");
    }
    throw error;
  }

  try {
    const session = await getSession();
    return { success: true, data: session.data };
  } catch (error) {
    if (getErrorCode(error) === 'email_not_verified') {
      await sendVerificationEmailIfAllowed();
      return {
        success: false,
        requiresVerification: true,
        message: "Email not verified. Verification email sent.",
      };
    }
    throw toApiError(error);
  }
}

let pendingSession = null;

// Login and Firebase's auth state listener both ask for the session; sharing one
// request keeps the server from activating the same account twice in parallel.
// The server keeps this tab in its company, or picks the one last active.
export const getSession = () => {
  if (!pendingSession) {
    pendingSession = axios.post("/auth/login", { user_id: selectedMembershipId() }).finally(() => {
      pendingSession = null;
    });
  }

  return pendingSession;
}

// Signing out counts as activity in this tab's company, so the next login
// returns to it even when another tab switched company later.
export const endSession = () => {
  const userId = selectedMembershipId();
  if (!auth.currentUser || !userId) {
    return Promise.resolve();
  }

  return axios.post("/auth/logout", { user_id: userId }).catch(() => {});
}

export const getErrorCode = (error) => error?.response?.data?.code;

export const toApiError = (error) => {
  const message = error?.response?.data?.error;
  if (!message) {
    return error;
  }

  const apiError = new Error(message);
  apiError.code = getErrorCode(error);
  return apiError;
}
